<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  async created () {

  }
}
</script>

<style lang="scss">
@import './styles/core';

td {
  white-space: nowrap;
}
</style>
